import { createContext } from "react";
import { WizardFormData } from "../Models/WizardModel";

interface WizardContext {
    wizardFormData: WizardFormData;
    setWizardFormData: React.Dispatch<React.SetStateAction<WizardFormData>>;
}
export const WizardContext = createContext<WizardContext>({wizardFormData: {} as WizardFormData, setWizardFormData: () => {}});